module.exports = __webpack_public_path__ + "static/media/Empanelment-two.6eb9cb55.png";